export default __webpack_public_path__ + "static/media/blanc.6541901f.jpg";